import { Model } from '@/models/Model';

export class SubCategory extends Model
{
  protected $name: string = 'SubCategory';
  protected $endpoint: string = '/sub-categories';
  protected $fillable: string[] = ['name', 'category', 'short_name'];

  public name?: string;
  public id?: string;
  public short_name?: string;
  public category?: string;
}
